import { reportHandle } from './index'
import {
  IClickGet,
  bookGetParam,
  IBookGet,
  IReportHandleParm,
  ICurrentGet,
  IErrorGet,
  IPayGet
} from './types'

/**
 * 点击类上报
 * @param obj
 */
export const clickGet = (obj: IClickGet) => {
  reportHandle({ type: 12, param: obj })
}
/**
 * 通用事件上报
 * @param obj
 */
export const eventGet = (obj: IClickGet) => {
  reportHandle({ type: 13, param: obj })
}
/**
 * 虚拟币消耗 获得类上报
 * @param obj
 */
export const _currentGet = (obj: ICurrentGet) => {
  reportHandle({ type: 5, param: obj })
}

/** 书籍相关事件上报函数 */
export const bookGet = (obj: bookGetParam) => {
  const { book_id, scenario, chapter_id, book_type, source, type } = obj

  const arr: IReportHandleParm[] = []

  const param: IBookGet = {
    parm1: type,
    parm3: 2, // 当前自动解锁章节开启状态 默认报关闭
    parm4: 0,
    parm5: chapter_id ? String(chapter_id) : '0', // 当前阅读章节ID,从阅读历史获取
    parm6: book_id, // 当前阅读进入书籍ID
    parm7: scenario || '1', // 当前游戏场景位置 1-主界面  2-小说阅读
    parm8: source, // 书籍入口
    parm10: book_type
  }

  reportHandle({ type: 7, param })
}

/** 错误事件上报 */
export const errorGet = (obj: IErrorGet): void => {
  reportHandle({ type: 8, param: obj })
}

/** 支付事件上报 */
export const payGet = (obj: IPayGet): void => {
  reportHandle({ type: 3, param: obj })
}
